import { Button, Input } from 'semantic-ui-react';
import './styles.css';
import { ReactNode } from 'react';

type PageNavigationPropsType = {
    children: ReactNode;
    className?: string;
};
function PageNavigation({ children, className = '' }: PageNavigationPropsType) {
    return <div className={`extraction-nav ${className}`}>{children}</div>;
}

type NextPageButtonPropsType = {
    handleNextPage: () => void;
};
function NextPageButton({ handleNextPage }: NextPageButtonPropsType) {
    return (
        <Button className="extraction-nav__button" onClick={handleNextPage}>
            Next
        </Button>
    );
}

type PrevPageButtonPropsType = {
    handlePrevPage: () => void;
};
function PrevPageButton({ handlePrevPage }: PrevPageButtonPropsType) {
    return (
        <Button className="extraction-nav__button" onClick={handlePrevPage}>
            Prev
        </Button>
    );
}

type PageNavigationInputPropsType = {
    currentPage: number;
    handleSetPage: (page: number) => void;
    numberOfPages: number;
};
function PageNavigationInput({ currentPage, handleSetPage, numberOfPages }: PageNavigationInputPropsType) {
    return (
        <Input
            className="extraction-nav__page-input"
            label={`/${numberOfPages}`}
            labelPosition="right"
            value={currentPage}
            onChange={(__, d) => handleSetPage(Number(d.value))}
        />
    );
}

PageNavigation.PrevPageButton = PrevPageButton;
PageNavigation.Input = PageNavigationInput;
PageNavigation.NextPageButton = NextPageButton;

type FullPageNavigationPropsType = Omit<PageNavigationPropsType, 'children'> &
    NextPageButtonPropsType &
    PrevPageButtonPropsType &
    PageNavigationInputPropsType;

const FullPageNavigation = ({
    currentPage,
    handleNextPage,
    handlePrevPage,
    handleSetPage,
    numberOfPages,
    className,
}: FullPageNavigationPropsType) => {
    return (
        <PageNavigation className={className}>
            <PageNavigation.PrevPageButton handlePrevPage={handlePrevPage} />
            <PageNavigation.Input
                currentPage={currentPage}
                handleSetPage={handleSetPage}
                numberOfPages={numberOfPages}
            />
            <NextPageButton handleNextPage={handleNextPage} />
        </PageNavigation>
    );
};

export default PageNavigation;
export { FullPageNavigation };
